import { ChangeDetectorRef, Component, Directive, inject } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  firstValueFrom,
  pairwise,
  startWith,
  Subscription
} from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { IGetAgendamentoById } from 'src/app/services/AgendamentoService/agendamento.model';
import { AgendamentoService } from 'src/app/services/AgendamentoService/agendamento.service';
import { IGetCaminhaoResponse } from 'src/app/services/CaminhaoService/caminhao.model';
import { CaminhaoService } from 'src/app/services/CaminhaoService/caminhao.service';
import { CargaService } from 'src/app/services/CargaService/carga.service';
import { CarretaService } from 'src/app/services/CarretaService/carreta.service';
import { CavaloService } from 'src/app/services/CavaloService/cavalo.service';
import { ClienteService } from 'src/app/services/ClienteService/cliente.service';
import { DestinatarioService } from 'src/app/services/DestinatarioService/destinatario.service';
import { EmpresaService } from 'src/app/services/EmpresaService/empresa.service';
import { MotoristaService } from 'src/app/services/MotoristaService/motorista.service';
import { PatioService } from 'src/app/services/PatioService/patio.service';
import { PrecoService } from 'src/app/services/PrecoService/preco.service';
import { ServicoService } from 'src/app/services/ServicoService/servico.service';
import { StepFormService } from 'src/app/services/StepForm/step-form.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { TransportadoraService } from 'src/app/services/TransportadoraService/transportadora.service';
import { TipoCarretaService } from 'src/app/services/TipoCarretaService/tipoCarreta.service';
import { IGetTipoCarreta } from 'src/app/services/TipoCarretaService/tipoCarreta.model';
import { EMPTY_OPTIONS } from './options-builder';
import { IOptions } from '../cadastro-agendamento.model';
import { IItems as IItemsMotorista } from 'src/app/services/MotoristaService/motorista.model';
import { IGetCarga } from 'src/app/services/CargaService/carga.model';
import { IItems as IItemsCarreta } from 'src/app/services/CarretaService/carreta.model';
import { IItems as ItemsCavalo } from 'src/app/services/CavaloService/cavalo.model';
import { IGetServicoResponse } from 'src/app/services/ServicoService/servico.model';
import { validarIsNullOrEmpty } from 'src/app/core/utils/utilities';
import { IGetPrecoResponse } from 'src/app/services/PrecoService/preco.model';
import { IGetCapacidadePatioVerification } from 'src/app/services/PatioService/patio.model';
import { IJanela } from 'src/app/services/JanelaService/janela.model';
import Swal from 'sweetalert2';
import { AcompanhantesService } from 'src/app/services/AcompanhanteService/acompanhantes.service';
import {
  IResponseAcompanhamento,
  IResponseAcompanhantesByAgendamento
} from 'src/app/services/AcompanhanteService/acompanhante.model';
@Directive()
export abstract class FormAgendamentoHandler {
  router = inject(Router);
  route = inject(ActivatedRoute);
  protected agendamentoService = inject(AgendamentoService);
  protected servicoService = inject(ServicoService);
  protected motoristaService = inject(MotoristaService);
  protected cavaloService = inject(CavaloService);
  protected carretaService = inject(CarretaService);
  protected precoService = inject(PrecoService);
  protected empresaService = inject(EmpresaService);
  protected caminhaoService = inject(CaminhaoService);
  protected swalAlert = inject(SwalAlertService);
  protected transportadoraService = inject(TransportadoraService);
  protected clienteService = inject(ClienteService);
  protected destinatarioService = inject(DestinatarioService);
  protected cargaService = inject(CargaService);
  protected patioService = inject(PatioService);
  protected acompanhantesService = inject(AcompanhantesService);
  protected tipoCarretaService = inject(TipoCarretaService);
  stepFormService = inject(StepFormService);
  cd = inject(ChangeDetectorRef);
  fb = inject(FormBuilder);

  protected subscription$ = new Subscription();
  currentStep: any;

  step2Form!: FormGroup;

  isLoading: boolean = false;
  guid: string = generateUUID();

  activeRoute: string = '';

  valorServico: any = '7,00';
  servicoOptions = EMPTY_OPTIONS.default();
  carretaOptions1 = EMPTY_OPTIONS.default();
  carretaOptions2 = EMPTY_OPTIONS.default();
  carretaOptions3 = EMPTY_OPTIONS.default();
  cavaloOptions = EMPTY_OPTIONS.default();
  transportadoraOptions = EMPTY_OPTIONS.default();
  clienteOptions = EMPTY_OPTIONS.default();
  destinatarioOptions = EMPTY_OPTIONS.default();
  cargaOptions = EMPTY_OPTIONS.default();
  tipoCarretaOptions = EMPTY_OPTIONS.default();
  janelaOptions: IOptions[] = [];

  motoristaOptions = EMPTY_OPTIONS.motorista();
  vinculosOptions = [
    { name: 'Ajudante', value: 1 },
    { name: 'Conferente', value: 2 },
    { name: 'Segurança', value: 3 },
    { name: 'Visitante', value: 4 },
    { name: 'Parente', value: 5 }
  ];

  copiedCarretaOptions1: IOptions[] = [];
  copiedCarretaOptions2: IOptions[] = [];
  copiedCarretaOptions3: IOptions[] = [];
  valueRemove: IOptions[] = [];
  idCaminhao: number = 0;

  turnoLabel: string = '';
  statusInput: boolean = false;
  statusAgendamentoValue: number = 0;
  motivoCancelamento: string = '';
  title: string = 'Novo Agendamento';
  disabledAgendamento: boolean = true;
  visible: boolean = false;
  idAgendamento: number = 0;
  form!: FormGroup;
  showNotaFiscal: boolean = true;

  isView =
    this.route.snapshot.queryParamMap.get('modoAgendamento') === 'Visualizar';

  statusAgendamento(): number {
    let status: number = 1;

    this.route.queryParams.subscribe(params => {
      if (Object.keys(params).length === 0) {
        status = 1;
        this.title = 'Novo Agendamento';
      } else {
        this.title = 'Editar Agendamento';
        this.disabledAgendamento = false;
        this.visible = true;
        this.idAgendamento = Number(params['codigo']);
        this.form.get('FK_SRVC')?.disable();

        if (params['modoAgendamento'] == 'Visualizar') {
          this.title = 'Visualização de Agendamento';
          this.statusInput = true;
          this.form.disable();
          this.step2Form?.disable();
          this.disabledAgendamento = true;
          status = 2;
        }
      }
    });

    return status;
  }

  async stateForms() {
    if (this.idAgendamento !== 0) {
      this.agendamentoService
        .GetAgendamentoById(this.idAgendamento)
        .subscribe((response: IGetAgendamentoById) => {
          this.statusAgendamentoValue = response.NU_STTS_AGND;
          this.motivoCancelamento = response.TX_MOTV_CNCL_AGND ?? '';
          const dtInput = this.toDateInputValue(response.DT_AGND);
          this.form.controls['DT_AGND'].setValue(dtInput);
          this.calcularTurno(dtInput);
          this.caminhaoService
            .GetCaminhaoByAgendamento(this.idAgendamento)
            .subscribe((res: IGetCaminhaoResponse) => {
              this.form.controls['FK_MTRT_EPSA'].setValue(
                res.FK_MTRT_EPSA ?? 0
              );
              this.form.controls['FK_CAVA'].setValue(res.FK_CAVA ?? 0);
              this.form.controls['FK_CRRT_1'].setValue(res.FK_CRRT_1 ?? 0);
              this.form.controls['FK_CRRT_2'].setValue(res.FK_CRRT_2 ?? 0);
              this.form.controls['FK_CRRT_3'].setValue(res.FK_CRRT_3 ?? 0);
              this.idCaminhao = Number(res.PK_CMNH);
              this.form.controls['FK_TPTD'].setValue(response.FK_TPTD);
              this.form.controls['FK_CLNT'].setValue(response.FK_CLNT);
              this.form.controls['FK_DTNR'].setValue(response.FK_DTNR);
              this.form.controls['FK_CRGA'].setValue(response.FK_CRGA);
              this.escolherCarga(response.FK_CRGA);
              this.form.controls['FK_TIPO_CRRT'].setValue(
                response.FK_TIPO_CRRT ?? 0
              );
              this.escolherTipoCarreta(response.FK_TIPO_CRRT);
            });
          this.form.get('FK_JNLA')?.setValue(response.FK_JNLA ?? null);
          this.form.controls['FK_SRVC'].setValue(response.FK_SRVC ?? 0);
          this.form.controls['TX_OBSV_AGND'].setValue(response.TX_OBSV_AGND);
          this.form.controls['TX_NOTA_FISCAL'].setValue(
            response.TX_NOTA_FISCAL ?? ''
          );
          this.form.controls['NU_PESO_TON'].setValue(response.NU_PESO_TON ?? 0);
          this.form.controls['NU_VOLUME'].setValue(response.NU_VOLUME ?? 0);
        });
    }
  }
  private toDateInputValue(dt: any): string {
    if (!dt) return '';
    const s = String(dt);
    // cobre "2008-02-02T00:00:00" e também Date.toString() ruim
    if (s.includes('T')) return s.split('T')[0];
    // se já vier "2008-02-02"
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    // fallback: tenta parsear
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '';
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  /**
   * O formulário guarda só a data (yyyy-MM-dd). A API exige DT_AGND > agora;
   * enviamos o fim do dia local da data escolhida.
   */
  protected dataAgendamentoParaApi(valor: unknown): string {
    const s = String(valor ?? '').trim();
    if (!s) return '';
    if (s.includes('T')) return s;
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
    if (!m) return s;
    const y = Number(m[1]);
    const mo = Number(m[2]) - 1;
    const d = Number(m[3]);
    const end = new Date(y, mo, d, 23, 59, 59, 999);
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${end.getFullYear()}-${pad(end.getMonth() + 1)}-${pad(end.getDate())}T${pad(end.getHours())}:${pad(end.getMinutes())}:${pad(end.getSeconds())}.${String(end.getMilliseconds()).padStart(3, '0')}`;
  }

  obterAcompanhantes() {
    const codigo = Number(this.route.snapshot.queryParams['codigo'] ?? 0);
    if (codigo) {
      this.acompanhantesService
        .getAcompanhantesByAgendamento({ FK_AGND: codigo })
        .subscribe({
          next: (res: IResponseAcompanhantesByAgendamento) => {
            if (res) this.patchStep2Acompanhantes(res.ACPN_LIST ?? []);
          }
        });
    }
  }
  private patchStep2Acompanhantes(items: IResponseAcompanhamento[]): void {
    const step2 = this.step2Form;
    const fa = step2.get('ACPN_LIST') as FormArray;
    console.clear;
    while (fa.length) fa.removeAt(0);

    items.forEach(x => {
      fa.push(
        this.fb.group({
          NM_ACPN: [x.NM_ACPN ?? null, [Validators.required]],
          NU_VNCL_MTRT: [x.NU_VNCL_MTRT ?? null],
          DT_NASC: [
            this.toDateInputValue(x.DT_NASC) ?? '',
            [Validators.required]
          ],
          TX_DOC_VNCL: [x.TX_DOC_VNCL ?? null],

          PK_ACPN: [x.PK_ACPN ?? null]
        })
      );
    });

    if (fa.length === 0) {
      fa.push(
        this.fb.group({
          NM_ACPN: ['', [Validators.required]],
          NU_VNCL_MTRT: [null],
          DT_NASC: ['', [Validators.required]],
          TX_DOC_VNCL: [null],
          PK_ACPN: [null]
        })
      );
    }

    step2.updateValueAndValidity({ emitEvent: false });
  }

  async getMotorista(status: number): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.motoristaService
        .GetMotoristaEmpresa({ paginar: false, status: status })
        .toPromise();

      this.motoristaOptions = response.ITEMS.map((x: IItemsMotorista) => ({
        name: x.NM_USUA_MTRT,
        value: x.PK_MTRT,
        cpf: x.TX_CPF_MTRT,
        cnh: x.TX_CNH_MTRT,
        telefone: x.NU_TELE_MTRT
      }));
    } catch (error) {
      console.error('Erro ao buscar motoristas:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async getServico(status: number): Promise<void> {
    this.isLoading = true;

    try {
      const response: IGetServicoResponse[] = await this.servicoService
        .GetServico(true)
        .toPromise();

      this.servicoOptions = response.map(x => ({
        name: x.TX_TIPO_SRVC,
        value: x.PK_SRVC
      }));
    } catch (error) {
      console.error('Erro ao buscar serviços:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async getPlacaCavalo(status: number): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.cavaloService
        .GetCavalo({ paginar: false, status: status })
        .toPromise();

      this.cavaloOptions = response.ITEMS.map((x: ItemsCavalo) => ({
        name: x.TX_PLCA_CAVA,
        value: x.PK_CAVA
      }));
    } catch (error) {
      console.error('Erro ao buscar placas de cavalo:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async getPlacaCarreta(status: number): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.carretaService
        .GetCarreta({ paginar: false, status: status })
        .toPromise();

      this.carretaOptions1 = response.ITEMS.map((x: IItemsCarreta) => ({
        name: x.TX_PLCA_CRRT,
        value: x.PK_CRRT
      }));
      this.carretaOptions2 = response.ITEMS.map((x: IItemsCarreta) => ({
        name: x.TX_PLCA_CRRT,
        value: x.PK_CRRT
      }));
      this.carretaOptions3 = response.ITEMS.map((x: IItemsCarreta) => ({
        name: x.TX_PLCA_CRRT,
        value: x.PK_CRRT
      }));

      this.copiedCarretaOptions1 = [...this.carretaOptions1];
      this.copiedCarretaOptions2 = [...this.carretaOptions2];
      this.copiedCarretaOptions3 = [...this.carretaOptions3];
    } catch (error) {
      console.error('Erro ao buscar placas de carreta:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async getTransportadora(): Promise<void> {
    this.isLoading = true;

    try {
      const response = await firstValueFrom(
        this.transportadoraService.getTransportadoras()
      );

      this.transportadoraOptions = response.Transportadoras.map(t => ({
        name: t.NM_TPTD,
        value: t.PK_TPTD
      }));
    } catch (error) {
      console.error('Erro ao buscar transportadoras:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async getCliente(): Promise<void> {
    this.isLoading = true;

    try {
      const response = await firstValueFrom(this.clienteService.getClientes());

      this.clienteOptions = response.Clientes.map(t => ({
        name: t.NM_CLNT,
        value: t.PK_CLNT
      }));
    } catch (error) {
      console.error('Erro ao buscar clientes:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async getDestinatario(): Promise<void> {
    this.isLoading = true;

    try {
      const response = await firstValueFrom(
        this.destinatarioService.getDestinatarios()
      );

      this.destinatarioOptions = response.Destinatarios.map(t => ({
        name: t.NM_DTNR,
        value: t.PK_DTNR
      }));
    } catch (error) {
      console.error('Erro ao buscar destinatarios:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async getCarga(): Promise<void> {
    this.isLoading = true;

    try {
      const response: IGetCarga[] = await firstValueFrom(
        this.cargaService.GetCarga()
      );

      this.cargaOptions = response.map(t => ({
        name: t.TX_CRGA,
        value: t.PK_CRGA
      }));
    } catch (error) {
      console.error('Erro ao buscar cargas:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async getTipoCarreta(): Promise<void> {
    this.isLoading = true;

    try {
      const response: IGetTipoCarreta[] = await firstValueFrom(
        this.tipoCarretaService.GetTipoCarreta()
      );

      this.tipoCarretaOptions = response.map(t => ({
        name: t.NM_TIPO_CRRT,
        value: t.PK_TIPO_CRRT
      }));
    } catch (error) {
      console.error('Erro ao buscar tipos de carreta:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async getJanelas(): Promise<void> {
    try {
      const res = await firstValueFrom(
        this.agendamentoService.getJanelasParaAgendamento()
      );
      this.janelaOptions = (res ?? []).map((j: IJanela) => ({
        name: `${j.HR_INIC} - ${j.HR_FIM}`,
        value: j.PK_JNLA
      }));
    } catch (error) {
      console.error('Erro ao buscar janelas:', error);
    }
  }

  public goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  escolherTransportadora(value: any): void {
    this.escolherOpcao('FK_TPTD', this.transportadoraOptions, value);
  }

  escolherCliente(value: any): void {
    this.escolherOpcao('FK_CLNT', this.clienteOptions, value);
  }

  escolherDestinatario(value: any): void {
    this.escolherOpcao('FK_DTNR', this.destinatarioOptions, value);
  }

  escolherCarga(value: any): void {
    this.escolherOpcao('FK_CRGA', this.cargaOptions, value);

    const carga = this.cargaOptions.find(c => c.value === Number(value));
    this.showNotaFiscal = !(carga?.name?.toLowerCase().includes('fertilizante'));

    const nfCtrl = this.form.get('TX_NOTA_FISCAL');
    if (!this.showNotaFiscal) {
      nfCtrl?.clearValidators();
      const nfAtual = nfCtrl?.value;
      if (nfAtual == null || nfAtual === '') {
        nfCtrl?.setValue(null);
      }
    } else {
      nfCtrl?.setValidators([Validators.required]);
    }
    nfCtrl?.updateValueAndValidity();
  }

  escolherTipoCarreta(value: any): void {
    this.escolherOpcao('FK_TIPO_CRRT', this.tipoCarretaOptions, value);
  }

  escolherJanela(value: any): void {
    this.escolherOpcao('FK_JNLA', this.janelaOptions, value);
  }
  escolherPlacaCavalo(value: any): void {
    this.escolherOpcao('FK_CAVA', this.cavaloOptions, value);
  }
  escolherPlacaCarreta(value: any, input: number): void {
    const carretasOptions = [
      this.carretaOptions1,
      this.carretaOptions2,
      this.carretaOptions3
    ];

    carretasOptions.forEach((carreta, index) => {
      if (index === input - 1) {
        this.escolherOpcao(`FK_CRRT_${input}`, carreta, value);
      } else {
        this.form.controls[`FK_CRRT_${input}`].valueChanges
          .pipe(startWith(null), pairwise())
          .subscribe(([prev, next]: [any, any]) => {
            const current = carreta.find(
              opcao => opcao?.value === Number(next)
            );

            const previous = this.valueRemove.find(
              opcao => opcao?.value === Number(prev)
            );

            if (current) {
              const indexToRemove = carreta.indexOf(current);
              if (indexToRemove !== -1) {
                carreta.splice(indexToRemove, 1);
              }
              this.valueRemove.push(current);
            }

            if (previous) {
              const indexToRemove = this.valueRemove.indexOf(previous);
              if (indexToRemove !== -1) {
                this.valueRemove.splice(indexToRemove, 1);
              }
            }
          });
      }
    });
  }
  escolherMotorista(value: any): void {
    this.escolherOpcao('FK_MTRT_EPSA', this.motoristaOptions, value);
    var motorista = this.motoristaOptions.find(
      opcao => opcao?.value === Number(value)
    );
    this.form.controls['TX_CPF'].setValue(motorista?.cpf);
    this.form.controls['TX_CNH'].setValue(motorista?.cnh);
    this.form.controls['NU_TELE'].setValue(motorista?.telefone);
  }

  escolherOpcao(campo: string, options: any[], value: any): void {
    const selecionado = options.find(opcao => opcao?.value === Number(value));

    this.atualizarCampo(campo, selecionado?.value);
  }
  atualizarCampo(campo: string, valor: any): void {
    if (this.form.controls[campo].value !== valor) {
      this.form.controls[campo].setValue(valor);
    }
  }

  escolherServico(value: any): void {
    this.escolherOpcao('FK_SRVC', this.servicoOptions, value);
    this.visible = false;

    if (!validarIsNullOrEmpty(value)) {
      this.precoService
        .GetPrecoAgendamentoByServico(Number(value))
        .subscribe((response: IGetPrecoResponse) => {
          // const responseValor = response.ITEMS;

          if (response == null) {
            this.swalAlert.showAlert(
              'Atenção',
              'Ocorreu uma falha para consultar o valor do serviço, por favor, escolha outra opção.',
              'warning',
              false,
              false,
              undefined
            );
          } else {
            this.visible = true;
            this.valorServico = this.formatarParaReal(
              String(response.preco.VL_SRVC ?? '')
            );
          }
        });
    }
  }
  formatarParaReal(value: string): string {
    const valueFormate = value.replace('.', ',');

    const partes = valueFormate.split(',');

    const parteInteira = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const parteDecimal = partes[1] ? `,${partes[1]}` : ',00';

    return `${parteInteira}${parteDecimal}`;
  }

  calcularTurno(dataHora: string): void {
    if (!dataHora) {
      this.turnoLabel = '';
      this.form.get('TURNO')?.setValue('');
      return;
    }
    const raw = String(dataHora).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      this.turnoLabel = '';
      this.form.get('TURNO')?.setValue('—');
      return;
    }
    const iso = raw.includes('T') ? raw : `${raw}T12:00:00`;
    const hora = new Date(iso).getHours();
    if (hora >= 7 && hora < 15) {
      this.turnoLabel = 'Matutino';
    } else if (hora >= 15 && hora < 24) {
      this.turnoLabel = 'Vespertino';
    } else {
      this.turnoLabel = 'Noturno';
    }
    this.form.get('TURNO')?.setValue(this.turnoLabel);
  }

  protected monitorarCamposAgendamento(): void {
    const cargaCtrl = this.form.get('FK_CRGA');
    const destinatarioCtrl = this.form.get('FK_DTNR');
    const dataCtrl = this.form.get('DT_AGND');

    if (!cargaCtrl || !destinatarioCtrl || !dataCtrl) return;

    dataCtrl.valueChanges.subscribe((value: string) => {
      this.calcularTurno(value);
    });

    combineLatest([
      cargaCtrl.valueChanges,
      destinatarioCtrl.valueChanges,
      dataCtrl.valueChanges
    ])
      .pipe(
        debounceTime(300), // evita chamadas excessivas
        distinctUntilChanged()
      )
      .subscribe(([carga, destinatario, data]) => {
        if (carga && destinatario && data) {
          this.validarRegraAgendamento(carga, destinatario, data);
        }
      });
  }
  consultarValor() {
    this.visible = false;

    if (this.form.valid && !this.title.includes('Visualizar')) {
      this.disabledAgendamento = !this.form.valid;
      this.visible = true;
    }
  }
  protected async validarRegraAgendamento(
    carga: number,
    destinatario: number,
    data: string
  ): Promise<void> {
    const dataApi = this.dataAgendamentoParaApi(data);
    const response: IGetCapacidadePatioVerification = await firstValueFrom(
      this.patioService.GetCapacidadePatioVerification(
        carga,
        destinatario,
        dataApi
      )
    );

    if (!response.FL_VAGA) {
      this.form.get('DT_AGND')?.reset();
      this.modalMensagemAgendamento(carga, destinatario, data);
    }
  }
  modalMensagemAgendamento(
    carga: number,
    destinatario: number,
    data: string
  ): void {
    const cargaValue = this.cargaOptions.find(x => x.value === carga);
    const destinatarioValue = this.destinatarioOptions.find(
      x => x.value === destinatario
    );

    Swal.fire({
      title: 'Capacidade de agendamentos atingida',
      html: `
        <p>O pátio atingiu o limite de agendamentos para:</p>
        <ul style="text-align: left; margin-left: 15%">
          <li><strong>Produto:</strong> ${cargaValue?.name ?? 'Não informado'}</li>
          <li><strong>Destinatário:</strong> ${destinatarioValue?.name ?? 'Não informado'}</li>
          <li><strong>Data:</strong> ${this.formatarData(data)}</li>
        </ul>
        <br>
        <p>Por favor, escolha outra data.</p>
      `,
      icon: 'warning'
    });
  }

  private formatarData(data: string): string {
    const s = String(data).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      const [y, mo, d] = s.split('-').map(Number);
      return new Date(y, mo - 1, d).toLocaleDateString('pt-BR');
    }
    const iso = s.includes('T') ? s : `${s}T12:00:00`;
    return new Date(iso).toLocaleString('pt-BR', {
      dateStyle: 'short',
      timeStyle: 'short'
    });
  }
}
